import { useMutation, useMutationState } from '@tanstack/react-query'

import { apiClient } from '../../apiClient'

const trackReadingTimeKey = (sessionId?: string) => ['training-session-track-reading', sessionId]

export function useTrackReadingTime(sessionId: string) {
  return useMutation({
    mutationKey: trackReadingTimeKey(sessionId),
    mutationFn: async (time: number) => {
      const { data } = await apiClient.post<{
        trainingSessionId: string
        suspensionEnded: boolean
        trainingReset: boolean
      }>(`/int/v3/engagements/training/sessions/${sessionId}/track-reading`, { timeToRead: time })
      return data
    },
  })
}

export function useTrackReadingTimeStatus(sessionId?: string) {
  const statuses = useMutationState({
    filters: { mutationKey: trackReadingTimeKey(sessionId), exact: true },
    select: (mutation) => mutation.state.status,
  })
  return sessionId ? statuses.at(-1) : undefined
}
